/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2023-02-24 10:34:25
 * @LastEditTime: 2023-03-20 09:40:17
 * @LastEditors: Please set LastEditors
 * @FilePath: /ops-manager-frontend/src/components/MonitorManage/RealTimeLog/ServiceLog.tsx
 */
import React, { useEffect, useState, useRef } from 'react';
import styles from './index.less';
import { Tabs, message } from 'sup-ui';
import { useIntl } from 'react-intl';
import messages from './messages';

import { useParams } from 'react-router-dom';

const { TabPane } = Tabs;

const ServiceLog = () => {
  const intl = useIntl();
  const routeParams = useParams();
  const { key } = routeParams; // 服务名
  const [containerList, setContainerList] = useState<any[]>([]); // 容器列表
  let websocket: any = null;
  const [logText, setLogText] = useState(''); // 日志内容
  const logRef = useRef<any>({ currtent: '' }); // 存储历史日志内容
  const fixedRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    getData(0);
  }, []);

  // 根据缓存信息获取对应容器信息
  const getData = (index: number) => {
    const logs = JSON.parse(sessionStorage.getItem('serviceLog') || '');
    const envStatus = JSON.parse(sessionStorage.getItem('envStatus') || '');

    if (key && Object.keys(logs).length) {
      const data = logs[key][index];
      setContainerList(logs[key]);
      const { podName, namespace, containerName } = data;
      const params = {
        podName,
        namespace,
        containerName,
        runtimeEnvId: envStatus?.runtimeEnvId,
      };
      createWebsocket(params);
    }
  };

  // 切换容器
  const tabChange = (key: number) => {
    logRef.current = '';
    setLogText('');
    getData(key);
  };

  // 获取实时日志
  const createWebsocket = (params: any) => {
    const url = `ws://${location.host}/websocket/log`;
    websocket = new WebSocket(url);
    websocket.onopen = () => {
      websocket.send(JSON.stringify(params));
    };

    websocket.onmessage = (res: any) => {
      if (res.data) {
        logRef.current = logRef.current + res.data;
        setLogText(logRef.current);
        // 让检测结果显示滚动到视口
        if (fixedRef?.current) {
          fixedRef.current.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
      }
    };

    websocket.onmerror = () => {
      message.error(intl.formatMessage(messages.linkFail));
    };
  };

  return (
    <div className={styles.serviceLog}>
      <h3 className={styles.title}>
        {key} {intl.formatMessage(messages.title)}
      </h3>
      <Tabs onChange={tabChange} animated={false}>
        {containerList?.map((item: any, index: number) => (
          <TabPane tab={item.containerName} key={index} />
        ))}
      </Tabs>
      <div className={styles.content}>
        {logText ? <pre>{logText}</pre> : <span>{intl.formatMessage(messages.logNull)}</span>}
        <div ref={fixedRef} />
      </div>
    </div>
  );
};

export default ServiceLog;
